import { getCurrentHostname } from './getCurrentHostname';
import { shouldAttemptHostnameTenantResolve } from './resolveTenantBusiness';

/**
 * Clave pública para URLs `/menu/:key` (prefiere slug sobre id interno).
 * @param {string | { slug?: string, id?: string, business?: { slug?: string } } | null | undefined} source
 */
export function resolvePublicMenuRouteKey(source) {
  if (source == null) return '';
  if (typeof source === 'string') return String(source).trim();
  const slug = String(source.slug ?? source.business?.slug ?? '').trim();
  if (slug) return slug;
  return String(source.id ?? '').trim();
}

/**
 * Rutas del menú público: con :businessId en la URL se usa /menu/:id/...;
 * en modo hostname (sin id en la ruta) se usan paths en la raíz.
 *
 * @param {string} routeBid - useParams().businessId solo cuando la ruta es /menu/:businessId/...
 * @param {'home'|'catalog'|'checkout'|'assistant'|'profile'} page — `home` abre el catálogo (inicio del menú).
 * @returns {string}
 */
export function getPublicMenuPath(routeBid, page) {
  const id = resolvePublicMenuRouteKey(routeBid);
  if (id) {
    if (page === 'home' || page === 'catalog') return `/menu/${id}`;
    return `/menu/${id}/${page}`;
  }
  switch (page) {
    case 'home':
    case 'catalog':
      return '/catalog';
    case 'checkout':
      return '/checkout';
    case 'assistant':
      return '/assistant';
    case 'profile':
      return '/profile';
    default:
      return '/catalog';
  }
}

/**
 * Inicio del menú cuando solo tenemos el id del negocio (p. ej. OrderStatus).
 * En host multi-tenant → /catalog ; si no → /menu/:id
 */
export function getPublicMenuHomeLink(businessId) {
  const bid = resolvePublicMenuRouteKey(businessId);
  const h = getCurrentHostname();
  if (shouldAttemptHostnameTenantResolve(h)) return '/catalog';
  return bid ? `/menu/${bid}` : '/catalog';
}
